import update from 'react/lib/update';

const initialState = {
	isFetching: false,
	list: []
};

export default function authors(state = initialState, action) {
	
	switch (action.type) {			

		case "IS_FETCHING":
			return update(state, { isFetching: { $set: action.bool } });

		case "SET_AUTHORS_LIST":
			return update(state, { list: { $set: action.authors } });		

		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/state/domains/authors/reducer.js